import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import ContactUsForm from '../../forms/contactUs/ContactUsForm';
import { Box } from '../../components';
import { PageWithTabs } from '../../layouts';
import { Mutation } from 'react-apollo';
import CreateContactUs from '../../graphql/mutations/CreateContactUs';
import GetAllContactUs from '../../graphql/queries/GetAllContactUs';

const NEW_CONTACT_TABS = [{ title: 'Details', to: '/contact-us/create-new' }];

const CreateContact: React.FC<RouteComponentProps> = ({ history }) => {
  return (
    <PageWithTabs tabs={NEW_CONTACT_TABS} alignItems="inherit">
      <Box flexDirection="row" p={4}>
        <Mutation
          mutation={CreateContactUs}
          refetchQueries={[{ query: GetAllContactUs }]}
          onCompleted={() => {
            history.push('/contact-us');
          }}
        >
          {(createContact, { loading, error }) => (
            <ContactUsForm
              mutation={(values) =>
                createContact({
                  variables: {
                    data: {
                      name: values.name,
                      number: values.number,
                      email: values.email,
                      status: values.status.value,
                    },
                  },
                })
              }
              loading={loading}
              error={error}
              formType="create"
              isNewPost={true}
            />
          )}
        </Mutation>
      </Box>
    </PageWithTabs>
  );
};

export default CreateContact;



// WEBPACK FOOTER //
// ./src/containers/contactUs/CreateContact.tsx